import service from './request.js'

// 封装 GET 请求
export const get = (url, params = {}) => {
    return service.get(url, {params});
};

// 封装 POST 请求
export const post = (url, data = {}, config = {}) => {
    return service.post(url, data, config);
};

// 封装 PUT 请求
export const put = (url, data = {}) => {
    return service.put(url, data);
};

// 封装 DELETE 请求
export const del = (url, params = {}) => {
    return service.delete(url, {params});
};

// 文件上傳
export const upload = (url, file, onUploadProgress = null, extraData = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    Object.keys(extraData).forEach(key => {
        formData.append(key, extraData[key]);
    });

    return service.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
};

// 文件下載
export const download = (url, params = {}) => {
    const filename = params['fileName'].split('_').pop()
    return service.get(url, {
        params,
        responseType: 'blob',
    }).then((response) => {
        const blob = new Blob([response]);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
    });
};
export default {
    install(app) {
        app.config.globalProperties.$get = get;
        app.config.globalProperties.$post = post;
        app.config.globalProperties.$put = put;
        app.config.globalProperties.$del = del;
        app.config.globalProperties.$upload = upload;
        app.config.globalProperties.$download = download;
    }
};

